import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { extractDate, extractTime } from "../../config/helpers";
import { Get } from "../../config/api";
import { FARE, UPLOADS_URL } from "../../config/constants/api";
import { useSelector } from "react-redux";

const LimoBookingDetails = () => {
  const navigate = useNavigate();
  const [latestFares, setLatestFares] = useState(null);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const sliderRef1 = useRef(null);
  const sliderRef2 = useRef(null);
  const Location = useLocation();
  const data = Location.state?.data;
  const [images, setImages] = useState(null);
  const [pricing, setPricing] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const getAllLatestFares = () => {
    Get(FARE.getAllLatestFares, token)
      .then((response) => {
        if (response?.status) {
          setLatestFares(response?.data?.latestFares);
          setPricing(response?.data?.pricing);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  // const getPerMileRate = (serviceType) => {
  //   if (latestFares) {
  //     let service = latestFares.find((fare) => fare._id === serviceType);
  //     return service?.fare;
  //   }
  // };
  const getPerMileRate = (serviceType) => {
    if (latestFares && data) {
      let service = latestFares.find((fare) => fare._id === serviceType && fare.passengerCapacity === data?.passengerCapacity);
      return service?.fare;
    }
  };

  const sliderSettings2 = {
    // arrows: false,
    // style: {
    //   margin: "20px",
    // },
  };
  // const images = ["cbg.png", "cbg.png", "cbg.png", "cbg.png", "cbg.png"];
  useEffect(() => {
    if (!data) {
      navigate(-1);
    }
    getAllLatestFares();
    if (data?.car) {
      setImages([data?.car?.image, ...data?.car?.gallery]);
    }
    // eslint-disable-next-line
  }, []);
  const getTotalFare = () => {
    if (data) {
      let total = 0;
      if (data?.booking?.initialMileage) {
        total +=
          data?.booking?.initialMileage.toFixed(2) *
          getPerMileRate(
            data?.booking?.serviceType.charAt(0).toUpperCase() +
              data?.booking?.serviceType.slice(1).toLowerCase()
          );
      } else if (data?.booking?.finalMileage) {
        total +=
          data?.booking?.finalMileage.toFixed(2) *
          getPerMileRate(
            data?.booking?.serviceType.charAt(0).toUpperCase() +
              data?.booking?.serviceType.slice(1).toLowerCase()
          );
      }
      if (!(data?.booking?.type === "Subscription")) {
        total += data?.booking?.duration * pricing?.hourlyRate;
      }
      // get additional hour charges if subscription
      if (data?.booking?.type === "Subscription") {
        if (data?.booking?.duration > 6) {
          total += (data?.booking?.duration - 6) * pricing?.hourlyRate;
        }
      }
      return total;
    }
  };
  const getTotalAmount = () => {
    return (
      getTotalFare() +
      getGratuityRate() +
      (data?.booking?.tolls ? data?.booking?.tolls : 0) +
      (data?.booking?.surcharge ? data?.booking?.surcharge : 0) +
      (data?.booking?.rushHours
        ? data?.booking?.rushHours * pricing?.hourlyRate
        : 0) +
      pricing?.bookingFee +
      pricing?.serviceFee
    ).toFixed(2);
  };
  useEffect(() => {
    setNav1(sliderRef1.current);
    setNav2(sliderRef2.current);
    // eslint-disable-next-line
  }, [sliderRef1?.current, sliderRef2?.current, images]);

  const sliderSettings = {
    slidesToShow: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    // centerMode: true,
    responsive: [
      {
        breakpoint: 768, // Small screens
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const getTotalBeforeGratuity = () => {
    if (pricing) {
      return (
        pricing?.hourlyRate * data?.booking?.duration +
        (data?.booking?.finalMileage
          ? data?.booking?.finalMileage.toFixed(2)
          : data?.booking?.initialMileage.toFixed(2)) *
          getPerMileRate(
            data?.booking?.serviceType.charAt(0).toUpperCase() +
              data?.booking?.serviceType.slice(1).toLowerCase()
          )
      );
    }
  };
  const getGratuityRate = () => {
    return 0.2 * getTotalBeforeGratuity();
  };
  return (
    <>
      <Row justify="center">
        <Col md={23} xs={22}>
          <div
            className="bg-white rounded-lg sm:py-16 py-8 my-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="flex justify-start mx-1 lg:mx-8 mb-6">
              <div className="flex justify-center items-center">
                <IoIosArrowRoundBack
                  onClick={() => navigate(-1)}
                  className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
                />
                <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                  Payment Details
                </h3>
              </div>
            </div>

            <Row justify="start" className="my-4 mx-4 lg:mx-8">
              <Col xs={22} md={24} lg={20} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg flex max-sm:flex-col items-center justify-between xl:p-12 p-3 mx-4">
                  <div className="flex flex-col items-start justify-center max-sm:order-1">
                    <h5 className="font-euclid text-sm max-xl:text-xs text-black font-bold mb-1">
                      {/* Tue,Aug 24, 2024 at 10:00 AM (PDT) */}
                      {extractDate(data?.createdAt)} at{" "}
                      {extractTime(data?.createdAt)}
                    </h5>
                    <p className="font-euclid text-sm max-xl:text-xs text-gray-500 font-normal mb-2 sm:mr-4">
                      {/* Big potato market To Hotel California */}
                      {data?.booking?.pickupLocation?.address} To{" "}
                      {data?.booking?.dropoffLocation?.address
                        ? data?.booking?.dropoffLocation?.address
                        : "-"}
                    </p>
                    <p className="font-euclid text-sm max-xl:text-xs text-gray-500 font-normal mb-2 sm:mr-4">
                      {/* Total mileage: 20 miles */}
                      Total mileage:{" "}
                      {data?.booking?.finalMileage > 0
                        ? data?.booking?.finalMileage.toFixed(2)
                        : data?.booking?.initialMileage.toFixed(2)}{" "}
                      miles
                    </p>
                    <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                      ${pricing?.hourlyRate * data?.booking?.duration}/
                      {data?.booking?.duration}hrs
                    </h5>
                  </div>
                </div>
              </Col>
              <Col xs={22} md={24} lg={20} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-10 p-6 mx-4">
                  <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                    Chauffeur Details
                  </h5>
                  <div className="flex justify-center items-center my-4">
                    <div className="flex flex-col items-start lg:mr-36 mr-12">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Name
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {/* John Doe */}
                        {data?.chauffeur
                          ? data?.chauffeur?.firstName +
                            " " +
                            data?.chauffeur?.lastName
                          : "-"}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Contact
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {/* +866-876-4632 */}
                        {data?.chauffeur ? data?.chauffeur?.phone : "-"}
                        {/* {data?.chauffeur?.phone}  */}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row justify="start" className="my-4 mx-2 lg:mx-10">
              <Col xs={22} md={24} lg={20} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-10 p-6 mx-4">
                  <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                    Hourly Service in Manhattan
                  </h5>
                  <div className="flex justify-center items-center my-4">
                    <div className="flex flex-col items-start lg:mr-36 mr-12">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Vehicle Type
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {/* Black Luxury */}
                        {data?.booking?.serviceType} Luxury
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Mileage
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {/* 20 miles */}
                        {data?.booking?.finalMileage > 0
                          ? data?.booking?.finalMileage.toFixed(2)
                          : data?.booking?.initialMileage.toFixed(2)}
                        {/* {data?.booking?.finalMileage ? data?.booking?.finalMileage : data?.booking?.initialMilage } miles */}
                      </p>
                    </div>
                    <div className="flex flex-col items-start">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Booking Duration
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {/* 5 hours */}
                        {data?.booking?.duration} hours
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Rush Hour
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {/* No rush hour */}
                        {data?.booking?.rushHours} rush hours
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={22} md={24} lg={20} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-10 p-6 mx-4">
                  <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                    Pricing Breakdown:
                  </h5>
                  <div className="flex justify-center items-center my-4">
                    <div className="flex flex-col items-start lg:mr-36 mr-12">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        {/* Hourly Rate: $150 per hour */}
                        Hourly Rate: ${pricing?.hourlyRate} per hour
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        Total for {data?.booking?.duration} hours:{" "}
                        {data?.booking?.duration} hours × ${pricing?.hourlyRate}
                        /hour = ${pricing?.hourlyRate * data?.booking?.duration}
                        /{data?.booking?.duration}hrs
                        {/* Total for {data?.booking?.duration} hours: {data?.booking?.duration} hours × $150/hour = ${data?.booking?.duration*150} */}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Total Cost:
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        <p>
                          {/* Hourly Rate: 25 */}
                          Hourly Rate : ${data?.booking?.duration * 150}
                        </p>
                        <p>
                          Mileage fee: ${data?.booking?.serviceType} Luxury: $
                          {(data?.booking?.initialMileage >
                        data?.booking?.finalMileage
                          ? data?.booking?.initialMileage
                          : data?.booking?.finalMileage) *
                          getPerMileRate(
                            data?.booking?.serviceType.charAt(0).toUpperCase() +
                              data?.booking?.serviceType.slice(1).toLowerCase()
                          )}{" "}
                        </p>
                        <p>Booking fee: ${pricing?.bookingFee}</p>
                        <p>Service Fee: ${pricing?.serviceFee}</p>
                        <p>
                          {" "}
                          Gratuity: 20% x ${getTotalBeforeGratuity()} = $
                          {getGratuityRate()}
                        </p>
                      </p>
                    </div>
                    <div className="flex flex-col items-start">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Mileage Fee:
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        {data?.booking?.serviceType} Luxury: $
                        {(data?.booking?.initialMileage >
                        data?.booking?.finalMileage
                          ? data?.booking?.initialMileage
                          : data?.booking?.finalMileage) *
                          getPerMileRate(
                            data?.booking?.serviceType.charAt(0).toUpperCase() +
                              data?.booking?.serviceType.slice(1).toLowerCase()
                          )}{" "}
                        {/* ${data?.booking?.finalMilage ? data?.booking?.finalMilage*2.75 : data?.booking?.initialMilage*2.75 } */}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Total Amount:
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        ${getTotalAmount()}
                        {/* $750 */}
                        {/* {data?.booking?.duration * 150 +
                        data?.booking?.finalMilage
                          ? data?.booking?.finalMilage * 2.75
                          : data?.booking?.initialMilage * 2.75 + 1.50 + 1.75 + 161} */}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/* <Row justify="start" className="my-4 mx-2 lg:mx-10">
              <Col xs={22} md={24} lg={20} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-10 p-6 mx-4">
                  <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                    My Reviews against Chauffeur Service
                  </h5>
                  <div className="flex justify-center items-center my-4">
                    <div className="flex flex-col items-start lg:mr-36 mr-12">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Overall Rating
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        4.5
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Reviews against the Chauffeur:
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Aenean euismod bibendum laoreet. Proin gravida dolor sit
                        amet lacus accumsan et viverra justo commodo. Proin
                        sodales pulvinar tempor. Cum sociis natoque penatibus et
                        magnis dis parturient montes, nascetur ridiculus mus.
                        Nam fermentum, nulla luctus pharetra vulputate, felis
                        tellus mollis orci, sed rhoncus sapien nunc eget odio.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row> */}
          </div>
        </Col>
      </Row>
      {data?.car && (
        <Row justify="center">
          <Col md={23} xs={22}>
            <div
              className="bg-white rounded-lg sm:py-16 py-4 px-10 mb-12"
              style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
            >
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black py-4">
                Car Details
              </h3>
              <Row justify="left" gutter={[32, 32]}>
                {Array.isArray(images) && images.length > 0 && (
                  <Col
                    xxl={10}
                    xl={10}
                    xs={24}
                    className="customSlider sm:px-4 self-center innermultiple-slider"
                  >
                    <div>
                      <Slider
                        asNavFor={nav2}
                        ref={sliderRef1}
                        {...sliderSettings}
                      >
                        {Array.isArray(images) &&
                          images.map((image, index) => {
                            return (
                              <div key={index}>
                                <span>
                                  <img
                                    src={UPLOADS_URL + image}
                                    alt=""
                                    className="img-fluid"
                                    style={{
                                      width: "100%",
                                      maxHeight: "250px",
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      height: "250px",
                                    }}
                                  />
                                </span>
                              </div>
                            );
                          })}
                      </Slider>
                      <Slider
                        asNavFor={nav1}
                        ref={sliderRef2}
                        slidesToShow={
                          images ? images.length : data?.car?.gallery?.length
                        }
                        swipeToSlide={true}
                        focusOnSelect={true}
                        {...sliderSettings2}
                      >
                        {Array.isArray(images) &&
                          images.map((image, index) => {
                            return (
                              <div key={index} className="slider-nav">
                                <span>
                                  <img
                                    src={UPLOADS_URL + image}
                                    alt=""
                                    className="img-fluid"
                                    style={{
                                      width: "100%",
                                      height: "90px",
                                      objectFit: "cover",
                                      objectPosition: "center",
                                      maxWidth: "250px",
                                    }}
                                  />
                                </span>
                              </div>
                            );
                          })}
                      </Slider>
                    </div>
                  </Col>
                )}
                {data?.car && (
                  <Col xxl={12} xl={14} xs={24}>
                    <div className="flex justify-center my-4 w-full">
                      <div className="flex flex-col items-start w-full">
                        <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Car Brand
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {data?.car?.brand}
                        </p>
                        <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Car Model
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {data?.car?.model}
                        </p>
                        <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Service Type
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {data?.car?.serviceType}
                        </p>
                      </div>
                      <div className="flex flex-col items-start w-full">
                        <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Car Name
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {data?.car?.name}
                        </p>
                        <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Car Number
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {data?.car?.carNumber}
                        </p>
                        <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Passenger Capacity
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {data?.car?.passengerCapacity}
                        </p>
                      </div>
                    </div>
                    {/* <div className="flex flex-col items-start justify-center">
                  <div className="flex justify-between items-center w-full border-b-4 border-[#D9D9D9] border-dashed py-2">
                    <h3 className="font-tavi text-2xl text-black uppercase max-desktop:text-xl">
                      Lexus LS 460 L AWD
                    </h3>
                    <h4 className="font-euclid font-bold text-3xl text-black uppercase max-desktop:text-xl">
                      $550/6hrs
                    </h4>
                  </div>
                  <h5 className="font-tavi text-lg text-black mt-4">
                    Additional Details
                  </h5>
                  <p className="font-euclid text-sm text-[#6A6A6A] max-desktop:xs mb-4 pr-8">
                    Napa limo Reservation 6 hours deal Gratuities and gas
                    surcharge, not included Additional fees and restriction may
                    apply
                  </p>
                  <div className="flex justify-between items-center w-full my-4">
                    <div className="flex flex-col items-start justify-center">
                      <h5 className="font-tavi text-sm max-2xl:text-xs text-black">
                        Pickup time and date
                      </h5>
                      <p className="font-euclid text-sm max-2xl:text-xs text-[#6A6A6A] max-desktop:xs">
                        Feb 22, 2024 @ 02:00PM
                      </p>
                    </div>
                    <div className="h-[32px] w-[2px] bg-[#818181] mx-1"></div>
                    <div className="flex flex-col items-start justify-center">
                      <h5 className="font-tavi text-sm max-2xl:text-xs text-black">
                        Pickup Location
                      </h5>
                      <p className="font-euclid text-sm max-2xl:text-xs text-[#6A6A6A] max-desktop:xs">
                        ABC Location, City, Country
                      </p>
                    </div>
                    <div className="h-[32px] w-[2px] bg-[#818181] mx-1"></div>
                    <div className="flex flex-col items-start justify-center">
                      <h5 className="font-tavi text-sm max-2xl:text-xs text-black">
                        Drop-off Location
                      </h5>
                      <p className="font-euclid text-sm max-2xl:text-xs text-[#6A6A6A] max-desktop:xs">
                        ABC Location, City, Country
                      </p>
                    </div>
                  </div>
                  <h5 className="font-tavi text-lg text-black my-4">
                    Fees Payable
                  </h5>
                  <div className="flex flex-col items-center justify-center p-6 w-full bg-[#F5F5F5] rounded-lg">
                    <div className="flex justify-between items-center w-full mb-2">
                      <h5 className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        VAT
                      </h5>
                      <p className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        $0.00
                      </p>
                    </div>
                    <div className="flex justify-between items-center w-full mb-2">
                      <h5 className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        Additional Fees
                      </h5>
                      <p className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        $0.00
                      </p>
                    </div>
                    <div className="flex justify-between items-center w-full mb-2">
                      <h5 className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        Security Services
                      </h5>
                      <p className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        $0.00
                      </p>
                    </div>
                    <div className="flex justify-between items-center w-full mb-2">
                      <h5 className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        Subtotal
                      </h5>
                      <p className="font-euclid text-sm text-[#767676] max-desktop:xs">
                        $0.00
                      </p>
                    </div>
                    <div className="flex justify-between items-center w-full mb-2 border-y border-[#333333] py-2">
                      <h5 className="font-euclid text-sm text-[#333333] max-desktop:xs">
                        Total Paid:
                      </h5>
                      <p className="font-euclid text-sm text-[#333333] max-desktop:xs">
                        $0.00
                      </p>
                    </div>
                  </div>
                </div> */}
                  </Col>
                )}
              </Row>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default LimoBookingDetails;
